import { render, staticRenderFns } from "./columnsList.vue?vue&type=template&id=2cc9d551&scoped=true"
import script from "./columnsList.vue?vue&type=script&lang=js"
export * from "./columnsList.vue?vue&type=script&lang=js"
import style0 from "./columnsList.vue?vue&type=style&index=0&id=2cc9d551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9d551",
  null
  
)

export default component.exports